// Exported because the paste handler below filters on it while the toolbar's file dialog can only
// hint at it — `input.accept` is overridable in the OS picker — so whoever receives the file has to
// apply the same list.
export const ACCEPTED_IMAGE_MIME_TYPES = ['image/png', 'image/jpeg', 'image/gif', 'image/webp'];
